import { SystemsAndComponentsUtilities } from "../../../utils/systemsAndComponentsUtilities";
import { ns3451_elements } from "./nsdata/NS3451";

export class DocumentAI {
  static getSystemCode(classification: string): string {
    const number = classification.match(/\d+/)?.[0];
    if (number === null) {
      return classification;
    }
    return SystemsAndComponentsUtilities.getOptionWithKey(undefined, number + "")?.title ?? classification;
  }

  static getNSName(classification: string): string {
    const number = classification.match(/\d+/)?.[0];
    if (number === null) {
      return classification;
    }
    const element = ns3451_elements.find((element) => element.code + "" === number);
    return element
      ? element.code + " " + element.name_no
      : (SystemsAndComponentsUtilities.getOptionWithKey(undefined, number + "")?.title ?? classification);
  }
}

